import type { LeadFilters } from "../components/LeadsSearch";

/**
 * A named Leads-page view: everything the page can be set to, so it reopens
 * exactly as saved. Lives on the user (appPreferences.views.leads).
 * Column order and widths are not part of it because the table has neither.
 */
export interface LeadView {
  id: string;
  name: string;
  filters: LeadFilters; // includes visibleColumns
  sortBy: string;
  limit: number;
  createdAt: string;
}

export interface LeadViewsPref {
  items: LeadView[];
  /** Applied on a fresh open of the Leads page. */
  defaultId?: string | null;
}

export const EMPTY_LEAD_VIEWS: LeadViewsPref = { items: [] };
